import type { GetAdminUserSubscriptionsV2200SubscriptionsItem } from './getAdminUserSubscriptionsV2200SubscriptionsItem';

export type GetAdminUserSubscriptionsV2200 = {
  subscriptions?: GetAdminUserSubscriptionsV2200SubscriptionsItem[];
  success?: boolean;
  userId?: string;
};
